<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
    <div class="container-header-inner-list">
        <div class="row mb-4">
            <div class="col-md-6">
                <div class="title-wrapper">
                    <div>
                        <h1 class="title-default">Campos adicionais</h1>
                        <p class="welcome-message">
                            <button mat-icon-button routerLink="/configuracoes/servicos">
                                <mat-icon>arrow_back</mat-icon>
                            </button>
                            Visualize e gerencie os campos personalizados do formulário da ordem de serviço.
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-md-6 d-flex flex-column-reverse flex-lg-row justify-content-lg-end align-items-stretch align-items-lg-center gap-2 gap-lg-3 mt-3 mt-lg-0">
                <button mat-stroked-button class="btn-secondary btn-spinner" [class.btn-loading]="isExcluindoSelecionados"
                    [disabled]="isExcluindoSelecionados" [matMenuTriggerFor]="opcoesMenu">
                    @if(selection.hasValue()) { <span>Ações ({{selection.selected.length}})</span> } @else {
                    <span>Ações</span> }
                    <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
                    @if (isExcluindoSelecionados) { <mat-spinner diameter="20"></mat-spinner> }
                </button>
                <mat-menu #opcoesMenu="matMenu">
                    <span matTooltip="Selecione ao menos um campo adicional para excluir."
                        [matTooltipDisabled]="selection.hasValue()">
                        <button mat-menu-item (click)="abrirModalExcluir()" [disabled]="!selection.hasValue()">
                            <mat-icon class="material-symbols-outlined">delete</mat-icon>
                            <span>Excluir selecionados</span>
                        </button>
                    </span>
                </mat-menu>
                <button type="button" mat-flat-button class="btn-primary"
                    routerLink="/configuracoes/servicos/campos-adicionais/cadastrar">
                    <mat-icon class="material-symbols-outlined">add</mat-icon> Novo campo adicional
                </button>
            </div>
        </div>

        <form [formGroup]="model" (ngSubmit)="clickPesquisar()">
            <div class="row search-area">
                <div class="col-12 col-lg-6">
                    <mat-form-field appearance="outline">
                        <mat-label>Pesquisar</mat-label>
                        <input matInput type="text" formControlName="pesquisa"
                            placeholder="Busque pelo nome do campo...">
                        <button mat-icon-button matSuffix type="submit"
                            aria-label="Pesquisar"><mat-icon>search</mat-icon></button>
                    </mat-form-field>
                </div>
            </div>
        </form>

        @if(_isLoading && _dataSource.data.length === 0) {
        <app-loading-box-default-list></app-loading-box-default-list>
        } @else if(_dataSource.data.length > 0) {

        <table mat-table class="desktop-view" [dataSource]="_dataSource" matSort>
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="w-checkbox">
                    <mat-checkbox (change)="$event ? toggleAllRows() : null"
                        [checked]="selection.hasValue() && isAllSelected()"></mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" class="w-checkbox">
                    <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)"></mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="nome">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome do campo </th>
                <td mat-cell *matCellDef="let element">{{element.nome}}</td>
            </ng-container>
            <ng-container matColumnDef="tipo">
                <th mat-header-cell *matHeaderCellDef> Tipo </th>
                <td mat-cell *matCellDef="let element">{{element.descricaoTipoCampoAdicional}}</td>
            </ng-container>
            <ng-container matColumnDef="opcoes">
                <th mat-header-cell *matHeaderCellDef> Opções </th>
                <td mat-cell *matCellDef="let element">{{textoOpcoes(element)}}</td>
            </ng-container>
            <ng-container matColumnDef="obrigatorio">
                <th mat-header-cell *matHeaderCellDef class="text-center"> Obrigatório na criação da OS </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                    <span class="status-badge" [class.badge-vermelho]="element.isObrigatorioCriacao"
                        [class.badge-cinza]="!element.isObrigatorioCriacao">
                        {{ element.isObrigatorioCriacao ? 'Obrigatório' : 'Opcional' }}
                    </span>
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="text-center w-actions">Ações</th>
                <td mat-cell *matCellDef="let element" class="text-center w-actions">
                    <button mat-icon-button type="button" class="btn-spinner"
                        [class.btn-loading]="idCampoAdicionalExcluindo === element.idCampoAdicional"
                        [disabled]="idCampoAdicionalExcluindo === element.idCampoAdicional"
                        [attr.aria-label]="idCampoAdicionalExcluindo === element.idCampoAdicional ? 'Excluindo campo adicional' : 'Ações do campo adicional'"
                        [matMenuTriggerFor]="menu">
                        <span class="material-symbols-outlined">more_horiz</span>
                        @if (idCampoAdicionalExcluindo === element.idCampoAdicional) { <mat-spinner diameter="20"></mat-spinner> }
                    </button>
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/servicos/campos-adicionais/cadastrar',{idCampoAdicional: element.idCampoAdicional}]"><span
                                class="material-symbols-outlined">edit</span><span>Editar</span></button>
                        <button mat-menu-item (click)="abrirModalExcluir(element)"><span
                                class="material-symbols-outlined">delete</span><span>Excluir</span></button>
                    </mat-menu>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div class="mobile-view">
            @for (item of _dataSource.data; track item.idCampoAdicional) {
            <div class="card-mobile mb-3" [class.selected-card]="selection.isSelected(item)">
                <div class="card-header-mobile d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        <mat-checkbox (change)="$event ? selection.toggle(item) : null"
                            [checked]="selection.isSelected(item)" color="primary"></mat-checkbox>
                        <span class="text-bold">{{item.nome}}</span>
                    </div>
                    <button mat-icon-button type="button" class="btn-spinner"
                        [class.btn-loading]="idCampoAdicionalExcluindo === item.idCampoAdicional"
                        [disabled]="idCampoAdicionalExcluindo === item.idCampoAdicional"
                        [attr.aria-label]="idCampoAdicionalExcluindo === item.idCampoAdicional ? 'Excluindo campo adicional' : 'Ações do campo adicional'"
                        [matMenuTriggerFor]="menuMobile">
                        <span class="material-symbols-outlined">more_horiz</span>
                        @if (idCampoAdicionalExcluindo === item.idCampoAdicional) { <mat-spinner diameter="20"></mat-spinner> }
                    </button>
                    <mat-menu #menuMobile="matMenu">
                        <button mat-menu-item
                            [routerLink]="['/configuracoes/servicos/campos-adicionais/cadastrar',{idCampoAdicional: item.idCampoAdicional}]">Editar</button>
                        <button mat-menu-item (click)="abrirModalExcluir(item)">Excluir</button>
                    </mat-menu>
                </div>
                <div class="card-body-mobile p-3">
                    <div class="d-flex justify-content-between align-items-center gap-2">
                        <span>{{item.descricaoTipoCampoAdicional}}</span>
                        <span class="status-badge" [class.badge-vermelho]="item.isObrigatorioCriacao"
                            [class.badge-cinza]="!item.isObrigatorioCriacao">
                            {{ item.isObrigatorioCriacao ? 'Obrigatório' : 'Opcional' }}
                        </span>
                    </div>
                    @if (item.listaOpcoes.length) {
                    <p class="sub-section-sub-title mt-2 mb-0">{{textoOpcoes(item)}}</p>
                    }
                </div>
            </div>
            }
        </div>

        <div class="col-12 text-center mt-4 mb-5">
            <button mat-button class="btn-ver-mais btn-spinner" [class.btn-loading]="_isLoading"
                [disabled]="_isLoading || _dataSource.data.length >= _totalRegistros" (click)="proximaPagina()">
                <span class="material-symbols-outlined">expand_more</span> Ver Mais
                @if (_isLoading) { <mat-spinner diameter="20"></mat-spinner> }
            </button>
        </div>

        } @else {
        <app-empty-state icon="playlist_add" title="Nenhum campo adicional cadastrado"
            subtitle="Crie campos para registrar informações próprias da sua operação na ordem de serviço."></app-empty-state>
        }
    </div>
</div>
